import { Component, inject, input, signal, computed, OnInit } from '@angular/core';
import { ServiceProductItem, ServiceProductItemAuditTrailItem } from '@hjc/masterdata-types';
import { AuditTrailService } from '@services/audit-trail.service';
import { ServicesService } from '@services/services.service';
import { InfoComponent, InfoField } from '@components/info/info.component';
import { AuditTrailComponent } from '@components/audit-trail/audit-trail.component';
import { PageHeaderComponent } from '@components/page-header/page-header.component';

@Component({
  selector: 'md-view-service-details',
  imports: [InfoComponent, AuditTrailComponent, PageHeaderComponent],
  templateUrl: './view-service-details.component.html',
  styleUrl: './view-service-details.component.scss',
  standalone: true
})
export class ViewServiceDetailsComponent implements OnInit {
  private servicesService = inject(ServicesService);
  private auditTrailService = inject(AuditTrailService);

  serviceItem = signal<ServiceProductItem | undefined>(undefined);
  auditTrail = signal<ServiceProductItemAuditTrailItem[]>([]);

  serviceId = input.required<string>();

  infoFields = computed<InfoField[]>(() => [
    { key: 'id', labelKey: 'FIELDS.CODE', type: 'string' },
    { key: 'name.fi', labelKey: 'FIELDS.DESCRIPTION', type: 'string' },
    { key: 'createdAt', labelKey: 'FIELDS.SYSTEM.CREATED_AT', type: 'date', pipe: 'date', dateFormat: 'dd.MM.yyyy HH:mm' },
    { key: 'createdBy', labelKey: 'FIELDS.SYSTEM.CREATED_BY', type: 'string' },
    { key: 'updatedAt', labelKey: 'FIELDS.SYSTEM.UPDATED_AT', type: 'date', pipe: 'date', dateFormat: 'dd.MM.yyyy HH:mm' },
    { key: 'updatedBy', labelKey: 'FIELDS.SYSTEM.UPDATED_BY', type: 'string' }
  ]);

  ngOnInit(): void {
    const id = this.serviceId();
    if (id) {
      this.loadServiceItem(id);
      this.loadAuditTrail(id);
    }
  }

  private async loadServiceItem(id: string): Promise<void> {
    try {
      const response = await this.servicesService.getServiceById(id);
      this.serviceItem.set(response.data);
    } catch (error) {
      console.error('Error loading service data:', error);
    }
  }

  private async loadAuditTrail(id: string): Promise<void> {
    try {
      const response = await this.auditTrailService.getAuditTrail<ServiceProductItemAuditTrailItem>('serviceproduct', id);
      this.auditTrail.set(response?.data || []);
    } catch (error) {
      console.error('Error loading audit trail:', error);
    }
  }
}
